import { Box } from "@mui/material";
import { Edit } from "../../components";
import { ShopDetails } from "./details";

export const ShopEdit = (): JSX.Element => (
    <Edit
        queryOptions={{ meta: { embed: ["variants:offer_variant!inner(*,details:offer_detail!inner(*,...product!inner(product:name,variant,type,image,categoryId,gtin,mpn)))"] } }} 
        resource="shop"
        disableAuthentication 
        component={Box}
    >
        <ShopDetails />
    </Edit>
);

export default ShopEdit;
